import { render, staticRenderFns } from "./BuyerEdit.vue?vue&type=template&id=45881da0&scoped=true&"
import script from "./BuyerEdit.vue?vue&type=script&lang=js&"
export * from "./BuyerEdit.vue?vue&type=script&lang=js&"
import style0 from "./BuyerEdit.vue?vue&type=style&index=0&id=45881da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45881da0",
  null
  
)

export default component.exports